import { memo, MouseEvent as ReactMouseEvent } from 'react';

import EditorNavItem from 'dashboard/apps/InquiryTemplateEditor/EditorNavItem';
import EditorNavItemTooltip from 'dashboard/apps/InquiryTemplateEditor/EditorNavItemTooltip';
import { blockDoubleClick } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateTree/EditorRenameableNavItem';
import { TreeReferenceStep } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateTree/InquiryTemplateTreeProvider';
import { getNavItemAttributes } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateTree/shared';
import { WorkflowStep } from 'dashboard/models/workflow-version';
import useMeasureText from 'lib/hooks/useMeasureText';

const StepNavItem = ({
  step,
  containerWidth,
  withOverflowTooltip = true,
  active,
  disabled,
  onClick,
}: {
  id: string;
  step: TreeReferenceStep | WorkflowStep;
  containerWidth: number;
  withOverflowTooltip?: boolean;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
}) => {
  const { testId, displayName, prefixIcon } = getNavItemAttributes(step);
  const textWidth = useMeasureText({ text: displayName });
  return (
    <EditorNavItemTooltip
      content={displayName}
      trigger={
        <EditorNavItem
          id={testId}
          data-test={testId}
          title={displayName}
          aria-current={active ? 'location' : false}
          prefixIcon={prefixIcon}
          active={active}
          onClick={(e: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => {
            blockDoubleClick(e, onClick);
          }}
          disabled={disabled}
        >
          {displayName}
        </EditorNavItem>
      }
      shouldTriggerTooltip={withOverflowTooltip && containerWidth > 0 && textWidth > containerWidth}
    />
  );
};

export default memo(StepNavItem);
